import {debug as baseDebug} from '@sanity/cli-core'

export const serverDebug = baseDebug.extend('server')
